<div
  class="wrapper"
  [class.disabled-control]="isEdit && !isEditable"
>
  @if (isPossibleToEdit()) {
    <div class="color-picker-container">
      <div
        class="current-color-container"
        (click)="openColorModal($event)"
      >
        <div
          class="color-container"
          [style.background-color]="value">
        </div>
      </div>
    </div>
  } @else {
    <div
      class="color-container"
      [style]="{
        'background-color': value ? value : 'var(--grey-color)'
      }"
    ></div>
  }
</div>
